import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import auth from '@/store/auth'

/*PUBLIC*/
import kiriminaja from '@/store/public/kiriminaja'
import options from '@/store/public/options'
import productInternal from '@/store/public/product-internal'
import productExternal from '@/store/public/product-external'
import productDiscussion from '@/store/public/product-discussion'
import productReview from '@/store/public/product-review'
import category from '@/store/public/category'
import banner from '@/store/public/banner'
import store from '@/store/public/store'
import content from '@/store/public/content'

/*MEMBER*/
import cart from '@/store/member/cart'
import address from '@/store/member/address'
import addressKiriminaja from '@/store/member/address-kiriminaja'
import transaction from '@/store/member/transaction'
import profile from '@/store/member/profile'

/*SELLER*/
import productSeller from '@/store/seller/product'
import transaksiSeller from '@/store/seller/pesanan'
import pembelianSeller from '@/store/seller/pembelian'
import saldoSeller from '@/store/seller/penghasilan'
import storeSeller from '@/store/seller/store'
import b2bSeller from '@/store/seller/B2b'

import {
	PAGE_TITLE
} from './mutation-types';


export default new Vuex.Store({
	state: {
		pageTitle: "Marketplace",
		alert: {
			show: false
		},
		loading: false
	},
	mutations: {
		[PAGE_TITLE](state, title) {
			state.pageTitle = title;
		},
		makeAlert(state, data) {
			if (data.code != 406) {
				state.alert = data
			}
		},
		progress(state, data) {
			state.loading = data
		},
		hideAlert(state) {
			state.alert.show = false
		},

	},
	actions: {
		setPageTitle({ commit }, title) {
			commit(PAGE_TITLE, title);
		},

	},
	modules: {
		auth,

		/*PUBLIC*/
		kiriminaja,
		options,
		productInternal,
		productExternal,
		category,
		banner,
		store,
		productDiscussion,
		productReview,
		content,

		/*MEMBER*/
		cart,
		address,
		addressKiriminaja,
		transaction,
		profile,

		/*SELLER*/
		productSeller,
		transaksiSeller,
		pembelianSeller,
		saldoSeller,
		storeSeller,
		b2bSeller,
	}
});
